import React from "react";
import NumberFormat from "react-number-format";
import moment from "moment";
import { formatWithMinDigits } from "../../../../../../../../utility/utils";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../../../../Utils/renderField/renderReadField";
import { useAnalisisDRC } from "../../hooks/useAnalisisDRC";
import { LAB_PRODUCCION_ESTADOS_DRC } from "../../../../../../../../utility/constants";

const CampoKilosHumedos = ({ kgHumedosInput, setKgHumedosInput }) => (
    <div className="formulario-field" style={{ maxWidth: "180px" }}>
        <label>Kilos húmedos</label>

        <NumberFormat
            className="form-control"
            value={kgHumedosInput}
            suffix=" Kg"
            thousandSeparator=","
            allowNegative={false}
            onValueChange={(values) => setKgHumedosInput(values.floatValue)}
            placeholder="0 kg"
        />
    </div>
);

export const AnalisisDRC = ({ almacenInventarioId, estaCerrado }) => {
    const {
        analisisActual,
        kgHumedosInput,
        setKgHumedosInput,
        SolicitarAnalisis,
        SolicitarNuevoAnalisis,
        nuevoAnalisis,
        setNuevoAnalisis,

        EditarSolicitudPendiente,
        editarSolicitud,
        setEditarSolicitud,
        cargando,
    } = useAnalisisDRC({ almacenInventarioId });

    let content = null;
    if (estaCerrado) {
        if (!analisisActual) {
            content = (
                <div
                    className="alert alert-info text-center font-weight-bold"
                    style={{ color: "white" }}
                >
                    No hay análisis de DRC registrados para este inventario.
                </div>
            );
        } else {
            const kgSecos = analisisActual.kg_humedos * analisisActual.drc;
            content = (
                <React.Fragment>
                    <div
                        className="alert alert-info text-center font-weight-bold"
                        style={{ color: "white" }}
                    >
                        El inventario está cerrado. No se pueden realizar
                        modificaciones.
                    </div>

                    <div className="formulario-fields-row">
                        <div className="formulario-field text-center">
                            <label>Kg húmedos enviados</label>
                            <RenderKilogramo
                                value={analisisActual.kg_humedos}
                            />
                        </div>

                        <div className="formulario-field text-center">
                            <label>Fecha solicitud</label>
                            <span>
                                {analisisActual.fecha_solicitud_analisis
                                    ? moment(
                                          analisisActual.fecha_solicitud_analisis,
                                      ).format("DD/MM/YYYY HH:mm")
                                    : "N/A"}
                            </span>
                        </div>

                        {analisisActual.estado ===
                            LAB_PRODUCCION_ESTADOS_DRC.DRC_VALIDO && (
                            <React.Fragment>
                                <div className="formulario-field text-center">
                                    <label>DRC laboratorio</label>
                                    <RenderNumberPercentage
                                        value={analisisActual.drc}
                                        decimalScale={3}
                                    />
                                </div>

                                <div className="formulario-field text-center">
                                    <label>Kg secos</label>
                                    <RenderKilogramo value={kgSecos} />
                                </div>

                                <div className="formulario-field text-center">
                                    <label>Fecha análisis</label>
                                    <span>
                                        {analisisActual.fecha_analisis
                                            ? moment(
                                                  analisisActual.fecha_analisis,
                                              ).format("DD/MM/YYYY")
                                            : "N/A"}
                                    </span>
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </React.Fragment>
            );
        }
    }

    if (!estaCerrado) {
        if (!analisisActual) {
            content = (
                <div>
                    <div
                        className="alert alert-info text-center font-weight-bold"
                        style={{ color: "white" }}
                    >
                        No hay análisis de DRC registrados para este inventario.
                    </div>

                    <div
                        className="formulario-fields-row"
                        style={{ justifyContent: "center" }}
                    >
                        <CampoKilosHumedos
                            kgHumedosInput={kgHumedosInput}
                            setKgHumedosInput={setKgHumedosInput}
                        />

                        <button
                            type="button"
                            className="btn btn-primary mt-4"
                            onClick={SolicitarAnalisis}
                        >
                            Solicitar análisis
                        </button>
                    </div>
                </div>
            );
        } else if (nuevoAnalisis) {
            content = (
                <div>
                    <div
                        className="alert alert-warning text-center font-weight-bold"
                        style={{ color: "white" }}
                    >
                        El nuevo análisis reemplazará el resultado actual.
                    </div>

                    <div
                        className="formulario-fields-row"
                        style={{ justifyContent: "center" }}
                    >
                        <CampoKilosHumedos
                            kgHumedosInput={kgHumedosInput}
                            setKgHumedosInput={setKgHumedosInput}
                        />
                    </div>

                    <div
                        className="d-flex justify-content-center"
                        style={{ gap: "1rem", marginTop: "2rem" }}
                    >
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setNuevoAnalisis(false)}
                        >
                            Cancelar
                        </button>

                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={SolicitarNuevoAnalisis}
                        >
                            Confirmar nuevo análisis
                        </button>
                    </div>
                </div>
            );
        } else if (editarSolicitud) {
            content = (
                <div>
                    <div
                        className="alert alert-warning text-center font-weight-bold"
                        style={{ color: "white" }}
                    >
                        Editando solicitud de análisis pendiente.
                    </div>

                    <div
                        className="formulario-fields-row"
                        style={{ justifyContent: "center" }}
                    >
                        <CampoKilosHumedos
                            kgHumedosInput={kgHumedosInput}
                            setKgHumedosInput={setKgHumedosInput}
                        />
                    </div>

                    <div
                        className="d-flex justify-content-center"
                        style={{ gap: "1rem", marginTop: "2rem" }}
                    >
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setEditarSolicitud(false)}
                        >
                            Cancelar
                        </button>

                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={EditarSolicitudPendiente}
                        >
                            Confirmar edición
                        </button>
                    </div>
                </div>
            );
        } else {
            const kgSecos = analisisActual.kg_humedos * analisisActual.drc;
            content = (
                <React.Fragment>
                    {(analisisActual.estado ===
                        LAB_PRODUCCION_ESTADOS_DRC.PENDIENTE_ANALISIS ||
                        analisisActual.estado ===
                            LAB_PRODUCCION_ESTADOS_DRC.DRC_RECHAZADO) && (
                        <div
                            className="alert alert-warning text-center font-weight-bold"
                            style={{ color: "white" }}
                        >
                            Pendiente de análisis
                        </div>
                    )}

                    {analisisActual.estado ===
                        LAB_PRODUCCION_ESTADOS_DRC.PENDIENTE_VALIDAR_DRC && (
                        <div
                            className="alert alert-info text-center font-weight-bold"
                            style={{ color: "white" }}
                        >
                            Análisis realizado, pendiente de validación
                        </div>
                    )}

                    {analisisActual.estado ===
                        LAB_PRODUCCION_ESTADOS_DRC.DRC_VALIDO && (
                        <div
                            className="alert alert-success text-center font-weight-bold"
                            style={{ color: "white" }}
                        >
                            Análisis completado
                        </div>
                    )}

                    <div className="formulario-fields-row">
                        <div className="formulario-field text-center">
                            <label>ID de Solicitud</label>
                            <span>
                                {formatWithMinDigits(analisisActual.id_base)}
                            </span>
                        </div>

                        <div className="formulario-field text-center">
                            <label>Kg húmedos enviados</label>
                            <RenderKilogramo
                                value={analisisActual.kg_humedos}
                            />
                        </div>

                        <div className="formulario-field text-center">
                            <label>Fecha solicitud</label>
                            <span>
                                {analisisActual.fecha_solicitud_analisis
                                    ? moment(
                                          analisisActual.fecha_solicitud_analisis,
                                      ).format("DD/MM/YYYY HH:mm")
                                    : "N/A"}
                            </span>
                        </div>

                        {analisisActual.estado ===
                            LAB_PRODUCCION_ESTADOS_DRC.DRC_VALIDO && (
                            <React.Fragment>
                                <div className="formulario-field text-center">
                                    <label>DRC laboratorio</label>
                                    <RenderNumberPercentage
                                        value={analisisActual.drc}
                                        decimalScale={3}
                                    />
                                </div>

                                <div className="formulario-field text-center">
                                    <label>Kg secos</label>
                                    <RenderKilogramo value={kgSecos} />
                                </div>

                                <div className="formulario-field text-center">
                                    <label>Fecha análisis</label>
                                    <span>
                                        {analisisActual.fecha_analisis
                                            ? moment(
                                                  analisisActual.fecha_analisis,
                                              ).format("DD/MM/YYYY")
                                            : "N/A"}
                                    </span>
                                </div>
                            </React.Fragment>
                        )}
                    </div>

                    <div
                        className="d-flex justify-content-center"
                        style={{ gap: "1rem" }}
                    >
                        {analisisActual.estado ===
                            LAB_PRODUCCION_ESTADOS_DRC.DRC_VALIDO && (
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => setNuevoAnalisis(true)}
                            >
                                Iniciar nuevo análisis
                            </button>
                        )}

                        {(analisisActual.estado ===
                            LAB_PRODUCCION_ESTADOS_DRC.PENDIENTE_ANALISIS ||
                            analisisActual.estado ===
                                LAB_PRODUCCION_ESTADOS_DRC.DRC_RECHAZADO) && (
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => setEditarSolicitud(true)}
                            >
                                Editar solicitud
                            </button>
                        )}
                    </div>
                </React.Fragment>
            );
        }
    }

    return (
        <LoadMask loading={cargando} blur>
            <div className="card mb-3 mt-4">
                <div className="card-body">
                    <h4 className="mb-3">
                        Análisis DRC de sobrante en almacén
                    </h4>

                    {content}
                </div>
            </div>
        </LoadMask>
    );
};
